import { ENV_PREFIX } from './constants';

export type EnvVariable = 'ADMIN_CLIENT_API_ULR';

function getEnvVariable(name: EnvVariable): string {
    let envVariable = '';
    if (process.env.NODE_ENV === 'production') {
        envVariable = (window.__ENV && window.__ENV[name]) ?? '';
    } else {
        envVariable = process.env[`${ENV_PREFIX}${name}`] ?? '';
    }
    return envVariable;
}

export default getEnvVariable;
